import SchoolIcon from "@mui/icons-material/School";
import WorkIcon from "@mui/icons-material/Work";
import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { Container, Grid, Paper, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import { Box } from "@mui/system";
import * as React from "react";
import myPic from "../../../images/IMG_20190213_121033_2.png";
import Footer from "../../../Shared/Footer/Footer";
import Header from "../../../Shared/Header/Header";
import "./AboutMe.css";
import About from "./AboutMeData";

const AboutMe = () => {
  return (
    <div
      style={{
        background:
          "linear-gradient(45deg, rgb(45, 54, 76) 0%, rgb(37, 45, 63) 100%)",
      }}
    >
      <Header />
      <Container>
        <Box>
          <Typography
            data-aos="zoom-out-down"
            className="section-title"
            sx={{ color: "whitesmoke" }}
            variant="h3"
          >
            About Me
          </Typography>
          <Box sx={{ my: 5 }}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12} md={6}>
                <Card
                  data-aos="fade-up"
                  data-aos-duration="3000"
                  sx={{ maxWidth: 400, opacity: ".8" }}
                >
                  <CardMedia
                    component="img"
                    height="400"
                    width="400"
                    image={myPic}
                    alt="green iguana"
                  />
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="2000"
                  className="about-text"
                  variant="body1"
                >
                  Hi! This is Rabbi,i'm complete my B.Sc in Computer Science &
                  Engineering. I am a MERN stack web developer trying to gain
                  confidence using my potential in the field of “Web
                  Development”. I will express my innovative creative skills for
                  self and company growth.
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box>
            <Typography
              className="section-title"
              sx={{ color: "whitesmoke", mb: 10 }}
              variant="h3"
            >
              Skills
            </Typography>
            <Box>
              <Grid
                container
                alignItems="center"
                spacing={{ xs: 2, md: 2 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                {About.map((about) => (
                  <Grid
                    justifyContent="center"
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    key={about.id}
                  >
                    <Paper
                      sx={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        bgcolor: "transparent",
                        height: 90,
                        width: 150,
                      }}
                    >
                      <Typography
                        variant="h3"
                        sx={{ color: `${about?.color}` }}
                      >
                        {about.icon}
                      </Typography>
                      <Typography
                        variant="body1"
                        color="whitesmoke"
                        fontWeight="bolder"
                      >
                        {about.name}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
          <Box>
            <Typography
              className="section-title"
              sx={{ color: "whitesmoke", mb: 10 }}
              variant="h3"
            >
              Educations & Experience
            </Typography>
            <Box>
              <Grid
                container
                justifyContent="space-between"
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item xs={12} md={12}>
                  <Paper sx={{ bgcolor: "transparent", color: "white" }}>
                    <Timeline position="alternate">
                      <TimelineItem>
                        <TimelineOppositeContent
                          sx={{ m: "auto 0" }}
                          variant="body2"
                          color="white"
                        >
                          2016 - 2021
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineConnector />
                          <TimelineDot>
                            <SchoolIcon />
                          </TimelineDot>
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: "12px", px: 2 }}>
                          <Typography variant="h6" component="span">
                            East West University
                          </Typography>
                          <Typography variant="body2">
                            Bachelor of Computer Science & Engineering
                          </Typography>
                        </TimelineContent>
                      </TimelineItem>
                      <TimelineItem>
                        <TimelineOppositeContent
                          sx={{ m: "auto 0" }}
                          variant="body2"
                          color="white"
                        >
                          2013 - 2015
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineConnector />
                          <TimelineDot color="primary">
                            <SchoolIcon />
                          </TimelineDot>
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: "12px", px: 2 }}>
                          <Typography variant="h6" component="span">
                            Dhaka Imperial Collage, Dhaka
                          </Typography>
                          <Typography variant="body2">
                            Higher Secondary Certificate, Science
                          </Typography>
                        </TimelineContent>
                      </TimelineItem>
                      <TimelineItem>
                        <TimelineOppositeContent
                          sx={{ m: "auto 0" }}
                          variant="body2"
                          color="white"
                        >
                          2011 - 2013
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineConnector />
                          <TimelineDot color="primary" variant="outlined">
                            <SchoolIcon />
                          </TimelineDot>
                          <TimelineConnector
                            sx={{ bgcolor: "secondary.main" }}
                          />
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: "12px", px: 2 }}>
                          <Typography variant="h6" component="span">
                            Khilgaon govt. High School
                          </Typography>
                          <Typography variant="body2">
                            Secondary School Certificate, Science
                          </Typography>
                        </TimelineContent>
                      </TimelineItem>
                    </Timeline>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Paper sx={{ bgcolor: "transparent", color: "white" }}>
                    <Timeline position="alternate">
                      <TimelineItem>
                        <TimelineOppositeContent
                          sx={{ m: "auto 0" }}
                          variant="body2"
                          color="white"
                        >
                          2021, present
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineConnector />
                          <TimelineDot>
                            <WorkIcon />
                          </TimelineDot>
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: "12px", px: 2 }}>
                          <Typography variant="h6" component="span">
                            Koyo Software Solutions
                          </Typography>
                          <Typography variant="body2">
                            FrontEnd Developer
                          </Typography>
                        </TimelineContent>
                      </TimelineItem>
                    </Timeline>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Container>
      <Footer></Footer>
    </div>
  );
};

export default AboutMe;
